import React from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectProfileImageUrl } from "../../store/profileImageSlice.js";
import { useChatScroll } from "../../hooks/sherpa/useChatScroll.js";
import SherpaIcon from "../../assets/Sherpa.svg";
import EmptyChatState from "./EmptyChatState.jsx";
import ChatMessage from "./ChatMessage.jsx";
import TypingIndicator from "./TypingIndicator.jsx";

const ChatMessageList = ({ messages, isSending, onQuickReply, onReport }) => {
  const userAvatar = useSelector(selectProfileImageUrl);
  const { containerRef, handleScroll } = useChatScroll([messages.length, isSending]);

  return (
    <Box
      ref={containerRef}
      onScroll={handleScroll}
      sx={{
        height: "100%",
        overflowY: "auto",
        px: { xs: 1.5, sm: 3 },
        py: 2,
        bgcolor: "#F7FBF8",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 900, mx: "auto" }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ mb: 1.25, px: 0.5 }}
        >
          <Avatar src={SherpaIcon} alt="Sherpa" sx={{ width: 32, height: 32 }} />
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 700, color: "#1A4C3B", lineHeight: 1.2 }}>
              Private mentor
            </Typography>
            <Typography variant="caption" sx={{ color: "#6D8278" }}>
              A private space to reflect and reset
            </Typography>
          </Box>
        </Stack>
        {messages.length === 0 ? (
          <EmptyChatState />
        ) : (
          <>
            {messages.map((message) => (
              <ChatMessage
                key={message.id}
                message={message}
                disabled={isSending}
                onQuickReply={isSending ? undefined : onQuickReply}
                onReport={onReport}
                userAvatar={userAvatar}
              />
            ))}
            {isSending ? <TypingIndicator /> : null}
          </>
        )}
      </Box>
    </Box>
  );
};

export default ChatMessageList;
